import React from 'react'

const ApproveIconGreen = () => {
    return (
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_25_919)">
                <path d="M11 0C4.91979 0 0 4.92031 0 11C0 17.0802 4.92031 22 11 22C17.0802 22 22 17.0797 22 11C22 4.91979 17.0797 0 11 0ZM11 20.5333C5.74333 20.5333 1.46665 16.2567 1.46665 11C1.46665 5.74329 5.74333 1.46665 11 1.46665C16.2567 1.46665 20.5333 5.74333 20.5333 11C20.5333 16.2567 16.2567 20.5333 11 20.5333Z" fill="#355E3B" />
                <path d="M16.8225 6.95795C16.5361 6.67157 16.0717 6.67157 15.7854 6.95795L9.25684 13.4865L6.2138 10.4435C5.92741 10.1571 5.46305 10.1571 5.1767 10.4435C4.89032 10.7299 4.89032 11.1942 5.1767 11.4806L8.73825 15.0421C9.0246 15.3285 9.48909 15.3284 9.77535 15.0421L16.8225 7.995C17.1089 7.70862 17.1089 7.24434 16.8225 6.95795Z" fill="#355E3B" />
            </g>
            <defs>
                <clipPath id="clip0_25_919">
                    <rect width="22" height="22" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}

export default ApproveIconGreen